import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import Select from 'react-select';
import MedicalApplicationForm from './MedicalApplicationForm'
import * as actions from '../actions/micustomeractions'
import * as Constants from '../constants'
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Documents from './Documents';
export default function MAFInfo() {

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);

    const filteredMemberList = state.memberBasicInfo?.filteredMemberList;
    const memberList = state.memberBasicInfo?.memberList;
    var masters = state.masters;
    let activeStep = state.activeStep;
    let basicInfoNewEnq = state?.basicInfoNewEnq;
    let medicalApplicationForm = state?.medicalApplicationForm ?? {}
    let LMPApplList = memberList?.filter(memb => memb?.memberGender == Constants.FEMALE_DOMAIN_ID_ID && memb?.relation != appConstants.RELATION_CHILDREN_ID)?.map(membb => membb?.memberId)
    let documents = state.quoteDocuments;
    const refDocument = useRef(null);
    useEffect(() => {
        async function mafQuestions() {
            dispatch(actions.updateMAFInfo({ name: "saveAttempted", value: false }));
            await dispatch(actions.getMafAnswers());
            await dispatch(actions.getMafQuestions());
            await dispatch(actions.getQuoteMembers(true))


        }
        mafQuestions();

    }, []);

    useEffect(() => {
        filteredMemberList.forEach(m => {
            let valuesToMap = [
                { ["memberFullName" + m.srlNo]: m.memberFullName },
                // { ["memberLastName" + m.srlNo]: m.memberLastName },
                { ["memberDateOfBirth" + m.srlNo]: m.memberDateOfBirth },
                { ["relation" + m.srlNo]: m.relation },
                { ["memberGender" + m.srlNo]: m.memberGender },
                { ["memberMaritalStatus" + m.srlNo]: m.memberMaritalStatus },
                { ["memberVisaEmirate" + m.srlNo]: m.memberVisaEmirate },
                { ["memberVisaType" + m.srlNo]: m.memberVisaType },
                { ["memberEntryDate" + m.srlNo]: m.memberEntryDate },
                { ["memberWeight" + m.srlNo]: m.memberWeight },
                { ["memberHeight" + m.srlNo]: m.memberHeight },
                { ["emiratesId" + m.srlNo]: m.emiratesId },
                { ["uidNumber" + m.srlNo]: m.uidNumber },
                { ["visaFileNumber" + m.srlNo]: m.visaFileNumber },

            ];
            valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
        });
    }, [filteredMemberList]);
    console.log('filteredMemberList', filteredMemberList);
    console.log('memberList', memberList);
    console.log('memberBasicInfo', state.memberBasicInfo);
    console.log('genderMasters', masters?.genderMasters);



    const handleBack = () => {
        dispatch(actions.handleNextStep(2))
    }
    const handleNext = () => {

        dispatch(actions.handleNextStep(4))
    }
    const skiptomemInfo = () => { //testing
        dispatch(actions.handleNextStep(1))
    }
    const scrollToDocument = () => {
        refDocument.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const onDocumentButton = async (memId) => {

        // await dispatch(actions.getQuoteDocumentList());
        // if (documents.documentList.length === 0) {
        await dispatch(actions.getQuoteDocumentMasters(memId));
        // }
        await dispatch(actions.setQuoteMemberForDocument(memId));
        await dispatch(actions.getQuoteDocuments(memId));

        await dispatch(actions.showMemberDocumentTab(memId));
        scrollToDocument();
    }
    const [selectedVisaEmirate, setSelectedVisaEmirate] = useState("");
    const [selectedVisaType, setVisaType] = useState("");

    const onAddMember = () => {
        reset();
        dispatch(actions.addMember());
        // resetField("firstName2");
    }
    const onDeleteMember = async (memberList) => {
        reset();


        dispatch(actions.deleteMember(memberList));
    }

    const updateBasicMemberInfoList = async (e) => {
        
        let id = e.target.id.match(/\d+/g)
        //id = id[0] - 1;
        var { name, value } = e.target;
        var inputName = name.match(/[a-zA-Z]+/g);
        name = inputName[0];

        if (name == "memberVisaEmirate" || name == "memberVisaEmirate") {
            value = value === "" ? null : Number(value);
        }

        if (name == 'emiratesId') {
            let memberListRec = memberList?.find(x => x?.srlNo == id)

            if (e.target.value.length === 3 && !memberListRec?.emiratesId?.match(/.*-$/)) {
                value = value += "-"
            }
            if (e.target.value.length === 8 && !memberListRec?.emiratesId?.match(/.*-$/)) {
                value = value += "-"
            }
            if (e.target.value.length === 16 && !memberListRec?.emiratesId?.match(/.*-$/)) {
                value = value += "-"

            }
            value = value.substr(0, 18);
        }



        // if (name.contains("emiratesId")) {
        //     if (e.target.value.length === 3 && !insuredInformation.emiratesId.match(/.*-$/)) {
        //         value = value += "-"
        //     }
        //     if (e.target.value.length === 8 && !insuredInformation.emiratesId.match(/.*-$/)) {
        //         value = value += "-"
        //     }
        //     if (e.target.value.length === 16 && !insuredInformation.emiratesId.match(/.*-$/)) {
        //         value = value += "-"
        //     }
        //     value = value.substr(0, 18);
        // }

        await dispatch(actions.updateBasicMemberInfoList({ id, name, value }));


        {
            let dynamicName = e.target.name
            let valuesToMap = [
                { [dynamicName]: value },
            ];
            await valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
        }
    }
    const onSubmit = async (data) => {
        await dispatch(actions.clearMemberDocument());
        dispatch(actions.updateMAFInfo({ name: "saveAttempted", value: true }));
        console.log('medicalApplicationForm', medicalApplicationForm.mafAnswers);



        if (!LMPApplList?.every(membe => medicalApplicationForm?.mafDateAnswers?.map(da => da?.memberId)?.includes(membe)) /* && medicalApplicationForm?.saveAttempted == true */) {
            return;
        }
        if (medicalApplicationForm?.mafAnswers?.length >= 0) {
            if (medicalApplicationForm?.mafAnswers?.some(w => w.memberIdList?.length <= 0)) {
                await dispatch(actions.toggleMafPopup())
                return;
            }
            //add check to see if a subquestion has no child answers selected
        }

        let dialogeData = {
            message: getTermsandConditions(),
            showConfirmPopup: true,
            isConfirm: true,
            isInfo: false,
            isComp: true,
            title: 'Terms & Conditions'
        }
        // console.log('dedede', medicalApplicationForm?.mafAnswers);

        if (!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued && medicalApplicationForm?.mafAnswers == 0) {
            const userResponse = await dispatch(actions.toggleConfirmPopup(dialogeData));
            if (userResponse == false) {
                return;
            }
        }


        console.log('memberBasicInfo Data:', state.memberBasicInfo);
        if (!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued) {
            var validated = await dispatch(actions.validateSaveMICustomerMemberBasicInfo());
            if(!validated){
                return false;
            }
            await dispatch(actions.saveMICustomerMemberBasicInfo(null, 2))
        }
        if (basicInfoNewEnq?.isRefertoUW) {
            let dialogeData = {
                message: ' The given premium is indicative. The quote will be referred to the underwriter to offer final premium . please make sure all members document upload.',
                showConfirmPopup: true,
                isConfirm: false,
                isInfo: true,

            }
            await dispatch(actions.toggleConfirmPopup(dialogeData));

        }


        // console.log('ewewew1', basicInfoNewEnq?.isRefertoUW);
        // if (basicInfoNewEnq?.isRefertoUW) {
        //     console.log('ewewew2', basicInfoNewEnq?.isRefertoUW);

        // }
        await dispatch(actions.toggleBasePremModel(false))
        await dispatch(actions.togglePlanTOBModel(false))
        if (!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued) {
            if (medicalApplicationForm?.mafQuestions?.length > 0) {
                await dispatch(actions.saveMedicalFormDetails());
            }
        }

        await dispatch(actions.getQuoteInformation({ encryptedEnquiryRefId1: basicInfoNewEnq?.encryptedEnquiryRefId1, encryptedEnquiryRefId2: basicInfoNewEnq?.encryptedEnquiryRefId2 }));

        handleNext()

    };

    function getTermsandConditions() {
        return (
            <div>
                <h4>Declartion:</h4>
                <ul >
                    <li style={{ textAlign: 'justify' }}>Are you under any medical observation/undergoing any medical/ surgical/ treatment or
                        have been advised for the same in the Past?

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes1'
                                name='yes1'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no1'
                                name='no1'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}> Are you taking any medication (pharmaceutical/alternative medicine) or have been advised?
                        Please specify the medication with the daily/weekly quantity in the last page?
                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes2'
                                name='yes2'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no2'
                                name='no2'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}> Have you undergone any surgery in the past or have you been advised to undergo any surgery in the near future?
                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes3'
                                name='yes3'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no3'
                                name='no3'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>  Do you have pre-existing or chronic conditions?
                        - Chronic Diseases: A disease with one or more of the following characteristics: lasts 3months or more, leaves residual
                        disability, is caused by non-reversible pathological alteration, requires special training of the patient for rehabilitation, or may
                        require a long period of supervision, observation, or care.
                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes4'
                                name='yes4'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no4'
                                name='no4'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>   Endocrine, Nutritional, Metabolic and/or immunity System (i.e. diabetes, thyroid or pituitary or testes problems, hormone
                        problems, gout, multiple sclerosis, cystic fibrosis, metabolic disorders, Vitamin D / Calcium deficiency, Menstrual related
                        disease (irregular periods. Excessive bleeding, Fibroids, ovarian cyst, Endometriosis, adenomyosis, etc. )
                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes5'
                                name='yes5'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no5'
                                name='no5'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    {LMPApplList?.length > 0 &&

                        <>
                            <li style={{ textAlign: 'justify' }}>   Are you currently Pregnant?
                                <div className='pt-2 pb-2'>
                                    <input
                                        type="checkbox"
                                        id='yes20'
                                        name='yes20'
                                        value="Y"
                                        className='form-check-input'
                                        checked={false}
                                        disabled={true}

                                    />
                                    YES
                                    &nbsp;
                                    <input
                                        type="checkbox"
                                        id='no20'
                                        name='no20'
                                        value="N"
                                        className='form-check-input'
                                        checked={true}
                                        disabled={true}

                                    />
                                    NO
                                </div>

                            </li>
                            <li style={{ textAlign: 'justify' }}>   Are you trying to get pregnant? ?
                                <div className='pt-2 pb-2'>
                                    <input
                                        type="checkbox"
                                        id='yes21'
                                        name='yes21'
                                        value="Y"
                                        className='form-check-input'
                                        checked={false}
                                        disabled={true}

                                    />
                                    YES
                                    &nbsp;
                                    <input
                                        type="checkbox"
                                        id='no21'
                                        name='no21'
                                        value="N"
                                        className='form-check-input'
                                        checked={true}
                                        disabled={true}

                                    />
                                    NO
                                </div>

                            </li>
                            <li style={{ textAlign: 'justify' }}>  Do you have earlier history of Caesarean Section, Premature Delivery or Premature babies? Or
                                any other complications related to maternity, till date?
                                <div className='pt-2 pb-2'>
                                    <input
                                        type="checkbox"
                                        id='yes22'
                                        name='yes22'
                                        value="Y"
                                        className='form-check-input'
                                        checked={false}
                                        disabled={true}

                                    />
                                    YES
                                    &nbsp;
                                    <input
                                        type="checkbox"
                                        id='no22'
                                        name='no22'
                                        value="N"
                                        className='form-check-input'
                                        checked={true}
                                        disabled={true}

                                    />
                                    NO
                                </div>

                            </li>
                            <li style={{ textAlign: 'justify' }}>  Have you undergone any treatment or taken any medications for infertility to achieve this pregnancy?
                                <div className='pt-2 pb-2'>
                                    <input
                                        type="checkbox"
                                        id='yes23'
                                        name='yes23'
                                        value="Y"
                                        className='form-check-input'
                                        checked={false}
                                        disabled={true}

                                    />
                                    YES
                                    &nbsp;
                                    <input
                                        type="checkbox"
                                        id='no23'
                                        name='no23'
                                        value="N"
                                        className='form-check-input'
                                        checked={true}
                                        disabled={true}

                                    />
                                    NO
                                </div>

                            </li>
                        </>

                    }










                    <li style={{ textAlign: 'justify' }}>Do you have any physical problems/disability for which you have undergone / currently undergoing physiotherapy or have
                        been advised for?
                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes6'
                                name='yes6'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no6'
                                name='no6'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}> Have you been ever diagnosed/treated and cured or undergoing treatments for cancer?

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes7'
                                name='yes7'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no7'
                                name='no7'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>Respiratory System (i.e. Sinusitis, allergies, tonsillitis/laryngitis, bronchitis, emphysema, Asthma, etc...)

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes8'
                                name='yes8'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no8'
                                name='no8'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}> Digestive System disease (i.e. Acid reflux, ulcers, diverticulitis, bleeding - infection - obstruction - perforation, problems of the
                        teeth / gum/ mouth / jaw, liver problem, gallbladder or pancreas, anal / rectal polyps etc..

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes9'
                                name='yes9'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no9'
                                name='no9'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}> Genitourinary System (i.e. kidney/ bladder infections, renal failure, kidney stones, salpingitis, ovarian cysts, prostate
                        problems, impotence, testicle infections, sperm abnormalities, breast disorders ,Hernia, etc.. )

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes10'
                                name='yes10'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no10'
                                name='no10'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>  Have you undertaken any blood tests, imaging tests e.g. Ultrasound, X-ray , CT-Scan ,MRI in the last 5 years?

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes12'
                                name='yes12'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no12'
                                name='no12'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>   Musculoskeletal or Connective tissue System (i.e. fracture, joint or cartilage problems, back bone infections, osteoporosis,
                        osteoarthritis, rheumatoid arthritis, Injury, migraine etc ...)?

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes13'
                                name='yes13'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no13'
                                name='no13'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>    Cardiovascular System (i.e., stroke, cerebral ischemia, rheumatic
                        fever Atherosclerosis, ischemic heart disease, hypertension,
                        heart valve disease, irregular heartbeat, pulmonary embolism,
                        phlebitis,Cholesterol , etc  .. )

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes15'
                                name='yes15'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no15'
                                name='no15'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>    Eye Disease (Increased Eye pressure, Cataract, vision correction surgery etc )?

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes16'
                                name='yes16'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no16'
                                name='no16'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify', paddingBottom: '3px' }}>   Skin disorders (Psoriasis, Chronic dermatitis, chronic skin allergies etc)?

                        <div className='pt-2 pb-2'>
                            <input
                                type="checkbox"
                                id='yes17'
                                name='yes17'
                                value="Y"
                                className='form-check-input'
                                checked={false}
                                disabled={true}

                            />
                            YES
                            &nbsp;
                            <input
                                type="checkbox"
                                id='no17'
                                name='no17'
                                value="N"
                                className='form-check-input'
                                checked={true}
                                disabled={true}

                            />
                            NO
                        </div>

                    </li>
                    <li style={{ textAlign: 'justify' }}>   I/We hereby declare with respect to both, myself and my dependents that to the best of my knowledge and belief, the statement on
                        application are full, true and correct and have declared all material facts related to this application.
                    </li>
                    <li style={{ textAlign: 'justify' }}>  I/We understand that non-disclosure or misrepresentation of any material fact may invalidate the quoted terms. I/We agree that all the
                        documents issued in connection with the policy shall be read together. If my application gets accepted. I/We agree to be bound by the
                        terms and conditions of the policy.

                    </li>
                    <li style={{ textAlign: 'justify' }}>  I/We hereby authorize any doctor, Hospital, Clinic or Medical Provider ,any Insurance Company or any other Company ,institution or
                        any other person who has any record or information about me and/or any of my family members to provide Al Sagr National Insurance
                        Company, with the complete information, including copies of their records with reference to any sickness or accident, any treatment,
                        examination, advice or hospitalization or any other medical information required by Al Sagr National Insurance Company. The Coverage
                        of Health Services provided by Al Sagr National Insurance Company is described in the policy wording.

                    </li>
                    <li style={{ textAlign: 'justify' }}>  By Approve this for, I/We acknowledge that I/We read, understood, and agree to the terms and conditions as stated in the policy wording.
                    </li>
                    <li style={{ textAlign: 'justify' }}>  I/We agree that after acceptance of the quoted premiums in the quotation, I/We shall be liable to pay all the premiums to Al Sagr
                        National Insurance Company as per the specified and selected plan of our choice.

                    </li>
                    <li style={{ textAlign: 'justify' }}>  Al Sagr National Insurance Company reserves the right to reject any authorization/claims request for conditions (pre-existing, chronic)
                        not declared by the applicant at the inception of the policy

                    </li>
                </ul>
            </div>
        )
    }
    const onErrors = (error) => {
        dispatch(actions.updateMAFInfo({ name: "saveAttempted", value: true }));

        console.log('Form Error:', error);
        // dispatch(actions.handleNextStep(2))
        // dispatch(actions.saveMICustomerEnquiry())
        //   setActiveStep((prevStep) => prevStep + 1);
    };

    // useEffect(() => {
    //     var value = basicInfoNewEnq.visaEmirate
    //     value = value === "" ? null : Number(value);
    //     if(value !== null)
    //     {
    //         if (basicInfoNewEnq?.visaEmirate) {
    //             setSelectedVisaEmirate(value);
    //         }
    //     }
    // }, [basicInfoNewEnq]);

    useEffect(() => {
        if (basicInfoNewEnq?.visaEmirate && filteredMemberList.length > 0) {
            filteredMemberList.forEach(memberList => {
                const simulatedEvent = {
                    target: {
                        id: `memberVisaEmirate${memberList.srlNo}`,
                        name: `memberVisaEmirate${memberList.srlNo}`,
                        value: basicInfoNewEnq.visaEmirate,
                    },
                };
                updateBasicMemberInfoList(simulatedEvent);
            });
        }
        setSelectedVisaEmirate(basicInfoNewEnq?.visaEmirate);
    }, [basicInfoNewEnq]);


    function renderMemberDetails() {
        const compareEmiratesIdYear = (dob, val) => {
            try {

                var dateofBirth = new Date(dob);
                var year = dateofBirth.getFullYear();
                var blankYear = '1111';
                const getYearFromEmiratesID = s => s.includes('-') && s.substr(s.indexOf('-') + 1).split('-')[0];
                if (year == getYearFromEmiratesID(val) || getYearFromEmiratesID(val) == blankYear) {
                    return true;
                }
                return false;
                //}
            } catch (error) {
                return false;
            }
        }
        return (
            <>
                {/* <div className="row g-2">
                    <div className="mb-2 col-md-1">
                    </div>
                </div > */}

                <form onSubmit={handleSubmit(onSubmit, onErrors)}>

                    <div className="table-responsive">
                        <table className="table table-hover table-custom table-responsive">
                            <thead className="table-header">
                                <tr>

                                    <th>No.</th>
                                    <th><span className='text-danger'>*</span> Full Name</th>
                                    <th><span className='text-danger'>*</span> Date of Birth</th>
                                    <th><span className='text-danger'>*</span> Relation</th>
                                    <th><span className='text-danger'>*</span> Gender</th>
                                    <th><span className='text-danger'>*</span> Marital Status</th>
                                    <th><span className='text-danger'>*</span> Visa Emirate</th>
                                    <th><span className='text-danger'>*</span> Visa File Number</th>
                                    {(selectedVisaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || selectedVisaEmirate == appConstants.VISA_EMIRATE_AL_AIN)
                                        // && (selectedVisaEmirate !== null && (selectedVisaEmirate !== ""))) 
                                        &&
                                        <th><span className='text-danger'>*</span> Visa Type</th>}
                                    {(selectedVisaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || selectedVisaEmirate == appConstants.VISA_EMIRATE_AL_AIN)
                                        &&
                                        <th><span className='text-danger'>*</span> Entry/Last coverage Date
                                        </th>


                                    }

                                    {(selectedVisaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || selectedVisaEmirate == appConstants.VISA_EMIRATE_AL_AIN)
                                        &&
                                        <>
                                            <th><span className='text-danger'>*</span> EID
                                            </th>

                                            <th><span className='text-danger'>*</span> UID (Unified Number)
                                            </th>
                                        </>


                                    }
                                    <th><span className='text-danger'>*</span> Height</th>
                                    <th><span className='text-danger'>*</span> Weight</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            {filteredMemberList.length != 0 ? (
                                <tbody>
                                    {filteredMemberList?.sort((a, b) => a.srlNo - b.srlNo)?.map((memberList, index) => (
                                        <tr key={memberList.srlNo} className="table-row">
                                            <td className='align-middle'>{memberList.srlNo}</td>
                                            <td>
                                                {memberList.memberFullName}
                                            </td>
                                            <td>
                                                {memberList.memberDateOfBirth}
                                            </td>
                                            <td>
                                                {masters?.relationMasters?.find(x => x.id == memberList.relation)?.name}
                                            </td>
                                            <td>
                                                {masters?.genderMasters?.find(x => x.id == memberList.memberGender)?.name}
                                            </td>
                                            <td>
                                                {masters?.maritalStatusMasters?.find(x => x.id == memberList.memberMaritalStatus)?.name}
                                            </td>
                                            <td>
                                                <select
                                                    style={{ width: '150px' }}
                                                    className={`form-control ${errors[`memberVisaEmirate${memberList.srlNo}`] ? "is-invalid" : ""}`} data-toggle="select2" name="memberVisaEmirate"
                                                    id={`memberVisaEmirate${memberList.srlNo}`}
                                                    disabled={true}
                                                    {...register(`memberVisaEmirate${memberList.srlNo}`,
                                                        {
                                                            required: "Field is Required",
                                                            onChange: (e) => {
                                                                setSelectedVisaEmirate(e.target.value);
                                                                updateBasicMemberInfoList(e);
                                                            }
                                                        }
                                                    )}
                                                >
                                                    <option value="">--Visa Emirate--</option>
                                                    {masters?.visaEmirateMasters?.filter(emirate => !appConstants.VISA_EMIRATE_COUNTRY.includes(emirate.id))?.map((visaEmirate) => (
                                                        <option value={visaEmirate.id} key={visaEmirate.id}>
                                                            {visaEmirate.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td>
                                                <input
                                                    className={`form-control ${errors[`visaFileNumber${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                    placeholder="Enter Visa File Number" id={`visaFileNumber${memberList.srlNo}`}
                                                    {...register(`visaFileNumber${memberList.srlNo}`, {
                                                        required: 'Field is required',
                                                         onChange: (e) => updateBasicMemberInfoList(e)
                                                    })}
                                                     value={memberList.visaFileNumber}
                                                />  
                                                
                                            </td>
                                            {(memberList?.memberVisaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || memberList?.memberVisaEmirate == appConstants.VISA_EMIRATE_AL_AIN) &&
                                                <td>
                                                    <select
                                                        style={{ width: '150px' }}
                                                        className={`form-control ${errors[`memberVisaType${memberList.srlNo}`] ? "is-invalid" : ""}`} data-toggle="select2" name="memberVisaType"
                                                        id={`memberVisaType${memberList.srlNo}`}
                                                        disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                        {...register(`memberVisaType${memberList.srlNo}`,
                                                            {
                                                                // required: "Field is Required", 
                                                                required: (memberList?.memberVisaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || memberList?.memberVisaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && "Field is required",
                                                                onChange: (e) => {
                                                                    // setVisaType(e.target.value);
                                                                    updateBasicMemberInfoList(e);
                                                                }
                                                            }
                                                        )}
                                                    >
                                                        <option value="">--Visa Type--</option>
                                                        {masters?.memberVisaType?.map((visaEmirate) => (
                                                            <option value={visaEmirate.domainValue} key={visaEmirate.domainValue}>
                                                                {visaEmirate.domainValueName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors[`memberVisaType${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                                </td>
                                            }
                                            {(memberList.memberVisaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || memberList.memberVisaEmirate == appConstants.VISA_EMIRATE_AL_AIN)
                                                &&
                                                <>
                                                    <td>
                                                        <input
                                                            className={`form-control ${errors[`memberEntryDate${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                            type="date"
                                                            placeholder='Enter Date'
                                                            id={`memberEntryDate${memberList.srlNo}`}
                                                            disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                            {...register(`memberEntryDate${memberList.srlNo}`, {
                                                                // required: true,
                                                                required: (memberList.memberVisaType) && "Field is required",
                                                                onChange: (e) => updateBasicMemberInfoList(e)
                                                            })}
                                                            value={memberList.memberEntryDate}
                                                        />
                                                        {errors[`memberEntryDate${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                                    </td>
                                                    <td>
                                                        <input style={{ width: '150px' }}
                                                            className={`form-control ${errors[`emiratesId${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                            placeholder="Enter Emirates ID"
                                                            id={`emiratesId${memberList.srlNo}`}
                                                            name={`emiratesId${memberList.srlNo}`}
                                                            disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                            // value={insuredInforamtion.emiratesId}
                                                            {...register(`emiratesId${memberList.srlNo}`, {
                                                                required: "Field is Required",
                                                                validate: {
                                                                    yearscheck: (v) => compareEmiratesIdYear(memberList?.memberDateOfBirth, v)
                                                                },
                                                                pattern: { value: /(^[7][8][4][-][0-9]{4}[-][0-9]{7}[-][0-9]{1}$)|(^[1][1][1][-][1]{4}[-][1]{7}[-][1]{1}$)/, message: "Format: XXX-XXXX-XXXXXXX-X" },

                                                                onChange: (e) => updateBasicMemberInfoList(e)
                                                            })}

                                                        />
                                                        {errors[`emiratesId${memberList.srlNo}`]?.message && <span className='text-danger fst-italic fs-6'>{errors[`emiratesId${memberList.srlNo}`]?.message}</span>}<br></br>
                                                        {errors[`emiratesId${memberList.srlNo}`]?.type === "yearscheck" && <span className="text-danger">Date of Birth Year and Emirates Id Year not Valid</span>}
                                                    </td>
                                                    <td>
                                                        <input
                                                            style={{ width: '150px' }}
                                                            className={`form-control ${errors[`uidNumber${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                            type="number"
                                                            placeholder='Enter UID'
                                                            id={`uidNumber${memberList.srlNo}`}
                                                            disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                            {...register(`uidNumber${memberList.srlNo}`, {
                                                                required: basicInfoNewEnq?.visaEmirate,
                                                                onChange: e => updateBasicMemberInfoList(e),
                                                            })}
                                                            value={memberList.uidNumber}
                                                        />
                                                        {errors[`uidNumber${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                                    </td>
                                                </>
                                            }
                                            <td>
                                                <input
                                                    className={`form-control ${errors[`memberHeight${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                    type="number"
                                                    placeholder='Enter Height'
                                                    id={`memberHeight${memberList.srlNo}`}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`memberHeight${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued, min: { value: 1, message: "Invalid Height" },
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                    value={memberList.memberHeight}
                                                />
                                                {errors[`memberHeight${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                            </td>
                                            <td>
                                                <input
                                                    className={`form-control ${errors[`memberWeight${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                    type="number"
                                                    placeholder='Enter Weight'
                                                    id={`memberWeight${memberList.srlNo}`}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`memberWeight${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued, min: { value: 1, message: "Invalid Weigth" },
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                    value={memberList.memberWeight}
                                                />
                                                {errors[`memberWeight${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                            </td>
                                            <td>
                                                <div ref={refDocument} style={{ textAlign: 'center' }} onClick={() => onDocumentButton(memberList?.memberId)}>

                                                    <AttachFileIcon
                                                        style={{ color: 'green', cursor: 'pointer' }}
                                                        titleAccess="Attach Document"

                                                    />
                                                    <div>Attach Document</div>
                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            <div className="alert alert-warning">No Members Found...</div>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                    <MedicalApplicationForm />

                    <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            className='mx-2'
                            variant="outlined"
                            type='button'
                            color="secondary"
                            onClick={handleBack}
                            startIcon={<ArrowBackIcon />}
                            disabled={activeStep === 0}
                        >
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            // onClick={handleNext}
                            endIcon={
                                <ArrowForwardIcon />
                            }
                        >
                            Next
                        </Button>

                    </Box>
                </form>
                {documents?.showMemberTab && <Documents />}

            </>
        )
    }

    return (
        <>
            <ul className="nav nav-tabs nav-bordered mb-1">
            </ul>
            <div className="row g-2">
                <div className="mb-1 col-md-12">
                </div>
            </div>
            <div className="collapse show" id="CollapseBasicMemberInfoQuote">
                {renderMemberDetails()}

            </div >
        </>

    )


}